import React, { useState, useEffect } from 'react'
import "./Style.css"
import { Link, useNavigate } from 'react-router-dom'
import { getPastSurveyList, getSurveyList, Pastsession } from '../Utils/utils'
import Loader from '../../Component/Loader/Loader'
import moment from 'moment'
import { FiSearch, FiChevronRight, FiChevronLeft } from "react-icons/fi";

const PastSurveyList = () => {
  const [pastseesiondata, setPastSessionData] = useState([]);
  const [Loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [count, setCount] = useState(10)
  const [surveys, setSurveys] = useState([]);
  const [totalPage, setTotalPage] = useState(0)
  const [search, setSearch] = useState('');
  const navigate = useNavigate();

  const surveyListing = async () => {
    var res = await getPastSurveyList(page, count, search)
    setTotalPage(res.metadata?.totalPage)
    setSurveys(res.data)
  }


  useEffect(() => {
    surveyListing()
  }, [page, search])





  return (
    <>
      {Loading && <Loader />}
      <div className="Passbooking-top">
        <div className='booking-wrapper mx-auto'>
          <div className='booking-top-container p-4'>
            <Link to="/survey-dashboard" style={{ textDecoration: 'none' }}>
              <img
                className="img-fluid left-arrow-img"
                src="./Images/left-arrow.svg"
                alt="arrow"
              />
            </Link>

            <span className='title d-flex align-items-center justify-content-center mt-3'>Survey List</span>
          </div>

          <div className='pastbooking-info p-3 bottom-padding'>
            {/* Past Bookings */}
            <div className='row w-100 m-auto emailinput search-div'>
              <div className='col-1 p-0 d-flex'>
                <FiSearch size={"20px"} color='#888888' />

              </div>
              <div className='col-11 p-0'>
                <input className='search-input ' type='text' placeholder='Search Here'
                  onChange={(e) => {
                    setPage(1)
                    setSearch(e.target.value)
                  }} />
              </div>
            </div>
            {surveys && surveys.map((a) => (

              <div className='survey-card'>
                <div className='card-date'>{moment(a?.createdAt).format('DD MMM, YYYY')}</div>
                <div className='card-pads'>
                  <div className="survey-name">{a?.name ? a?.name : a?.full_name}</div>
                  <div className='top-bottom-margin'>

                    <span className='survey-age'>{a?.age} Years</span>
                    <span className='survey-age' style={{ textTransform: 'capitalize' }}>{a?.gender}</span>
                    <span className='survey-age'>{a?.weight} Kgs</span>
                    <span className='survey-age'>{a?.height_foot}.{a?.height_inch}ft</span>
                  </div>
                  <div className='phone-num'>+{a?.phone_number}</div>
                  <div className='row btn-rows'>
                    <button className='outline-btn-2 ' type='submit' onClick={() => navigate(`/surveystepone?id=${a?._id}&edit=true`)}>
                      <span className='continuebtn-text cont-font' >Edit Now</span>
                    </button>
                    <button className='continue-btn-2 ' type='submit' onClick={() => navigate(`/survey-detail?id=${a?._id}`)}>
                      <span className='continuebtn-text cont-font' >View Now</span>
                    </button>
                  </div>
                </div>
              </div>
            ))}
            {totalPage > 1 &&
              <div className='w-100 row m-auto' style={{ justifyContent: 'end' }}>
                {page > 1 &&
                  <div className='arrow-style' style={{ paddingRight: '8px' }} onClick={() => {
                    setPage(page - 1)
                  }}>
                    <FiChevronLeft size={"20px"} color='#666666' />
                  </div>}
                {Array.from({ length: totalPage }, (_, index) => (
                  <div className={page == index + 1 ? `btm-number-selected` : `btm-number`} onClick={() => setPage(index + 1)}>{index + 1}</div>
                ))}
                {page != totalPage &&
                  <div className='arrow-style' onClick={() => {
                    setPage(page + 1)
                  }}>
                    <FiChevronRight size={"20px"} color='#666666' />
                  </div>}
              </div>
            }


          </div>
        </div>
      </div>
    </>


  )
}

export default PastSurveyList